<template>

  <div >
    <div
      ref="tools"
      tabindex="1"
      v-show="ui.show"
      class="tools"
      :style="{
        left: `${ui.x}px`,
        top: `${ui.y}px`
      }"
      @mousedown.prevent="">

      <button 
        v-for="(trait, i) in traits" 
        class="item btn-reset"
        :class="{'active': i == ui.currentTraitId}"
        :key="i"
        :style="{'backgroundColor': '#' + trait.highlight_color}"
        @mouseover="ui.currentLabel = $t(iKey('case_study_section', 'case_study_traits', 'label_' + i ))"
        @mousedown.prevent="highlight(i)"
        ></button>

      <button
        v-if="ui.showUnhighlight"
        class="item unhighlight btn-reset"
        @mouseover="ui.currentLabel = $t(iKey('case_study_section', 'case_study_traits', 'remove_highlight' ))"
        @mousedown.prevent="unHighlight()">
      </button>

      <div class="divider mx-2"></div>
      <div v-html="ui.currentLabel" class="current-label" ></div>

    </div>
    
    <div :id="containerId" ref="text_container" class="slot-wrap" tabindex="1">
      <slot />
    </div>
    
  </div>
  
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Highlightable',
  data () {
    return {
      ui: {
        x: 0,
        y: 0,
        show: false,
        showUnhighlight: false,
        currentLabel: this.$t(this.iKey('case_study_section', 'case_study_traits', 'select_color' )),
        currentTraitId: null
      },
      obj: {
        highlighter: {},
        classAppliers: []
      },
      selectionEndTimeout: null
    }
  },
  props: [
    'containerId'
  ],
  computed: {
    ...mapState('page', ['items']),
    highlightableEl () {
      return this.$slots.default[0].elm
    },
    traits: function() {
      let traits;
      this.items.case_study_section.forEach(obj => {
          if(obj.type == 'case_study_traits'){
              traits = obj.value.labels
          }
      })
      return traits
    }
  },
  mounted(){
    this.initHighlighter();
    this.$refs.text_container.addEventListener('mouseup', this.onMouseup)
    this.$refs.text_container.addEventListener('keyup', this.onMouseup)
    //this.$refs.text_container.addEventListener('onselectionchange', this.userSelectionChanged)
    // const container = document.getElementById(this.containerId)
    // document.onselectionchange = this.userSelectionChanged
  },
  beforeDestroy () {
    this.$refs.text_container.removeEventListener('mouseup', this.onMouseup)
  },
  methods: {
    initHighlighter() {
      this.$rangy.init();
      this.obj.highlighter = this.$rangy.createHighlighter();

      // create different highlight classes for each trait color
      this.traits.forEach((trait, index) => {
        let hiLightCls = 'highlighted-' + index
        let classApplier = this.$rangy.createClassApplier(hiLightCls)
        this.obj.highlighter.addClassApplier(this.$rangy.createClassApplier(hiLightCls));
        this.obj.classAppliers.push(classApplier)
      })
    },
    onMouseup () {
      this.ui.showUnhighlight = false;
      let sel = this.$rangy.getSelection();
      
      if (sel.rangeCount === 0 || sel.isCollapsed) {
        this.resetTool();
        return
      }
      const startNode = sel.getRangeAt(0).startContainer
      const endNode = sel.getRangeAt(0).endContainer
      const commonNode = sel.getRangeAt(0).commonAncestorContainer

      // already highlighted area? add option to remove
      let parentClass = commonNode.parentElement.classList.value
      if(parentClass.includes("highlighted")){
        this.ui.showUnhighlight = true;

        // determine which trait is used for highlighting and select
        this.obj.classAppliers.forEach((cls) => {
          
          if(cls.isAppliedToSelection()){
            let trait_id = cls.className.split('-')[1];
            this.ui.currentTraitId = trait_id
            this.ui.currentLabel = this.$t(this.iKey('case_study_section', 'case_study_traits', 'label_' + trait_id ))
          }
        })
      }

      // don't show tools if selection is across nodes (this includes across highlights)
      if((startNode != endNode) || (startNode != commonNode)){
        this.resetTool();
        return
      }      

      // selector positioning
      const rect  = sel.getRangeAt(0).nativeRange.getBoundingClientRect()
      const containerRect = document.getElementById('case_studies').getBoundingClientRect()

      this.ui.x = rect.x + (rect.width / 2)
      this.ui.y = (rect.y - 10) - containerRect.y 
      this.ui.show = true
      this.$refs.tools.focus();

    },
    
    highlight(color) {
      let hiString = 'highlighted-' + color
      this.obj.highlighter.highlightSelection(hiString, { containerElementId: this.$props.containerId });
      
      window.getSelection().removeAllRanges();
      this.resetTool()
    },

    unHighlight() {
      this.obj.highlighter.unhighlightSelection();
      this.resetTool();
    },

    resetTool() {
      this.ui.show = false;
      this.ui.currentLabel = this.$t(this.iKey('case_study_section', 'case_study_traits', 'select_color' ));
    }
  }
}
</script>

<style scoped>
.tools {
  height: 45px;
  padding: 5px 15px;
  background: #333333;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -100%);
  transition: 0.2s all;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 1;
  width: 320px;
}


.tools:after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -5px;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #333;
}

.item {
  color: #FFF;
  cursor: pointer;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.item.ylw {
  background: #ffd93d;
}
.item.pnk {
  background: #f2aeff;
}
.item.blu {
  background: #8ee8fb;
}
.item.unhighlight {
  background: #968c82;
  position: relative;
}
.item.unhighlight:after {
  position: absolute;
  width: 100%;
  height: 1px;
  content: "";
  display: block;
  left: 0;
  top: 50%;
  transform: rotate(-45deg);
  background: white;
}

.item:hover,
.item.active {
  border: 2px solid white;
}
.item + .item {
  margin-left: 10px;
}

.divider {
  border-left: 1px solid #968c82;
  height: 30px;
  display: inline-block;
  vertical-align: middle;
}

.current-label {
  color: white;
  font-size: 14px;
}


</style>

<style>
/* TODO: why must these be global styles? */
/* TODO: figure out how to apply multiple classes with rangy so we can have a base highlight class */
.highlighted-0 {
  position: relative;
  background-image: url('../../assets/highlight-ylw.png');
  background-repeat: repeat-x;
  background-position-y: bottom;
}

.highlighted-1 {
  position: relative;
  background-image: url('../../assets/highlight-pnk.png');
  background-repeat: repeat-x;
  background-position-y: bottom;
}

.highlighted-2 {
  position: relative;
  background-image: url('../../assets/highlight-blu.png');
  background-repeat: repeat-x;
  background-position-y: bottom;
}
</style>

